import Typography from '@components/std-components/Typography'
import { CATEGORY_INTERNAL_SEPERATOR } from '@components/UI-Components/HierarchyWiseItems/constants'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import formatNumberByLocale from '@utils/format-number-by-locale'
import classNames from 'classnames'
import last from 'lodash/last'
import split from 'lodash/split'
import startCase from 'lodash/startCase'
import React, { FC } from 'react'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import HierarchyCell from '../../components/HierarchyCell'
import * as css from './ActivityFamilyLine.css'

const ActivityFamilyLine: FC<CellItem> = ({ rowData, column }) => {
  if (!rowData) {
    return (
      <HierarchyCell>
        <FieldSkeleton />
      </HierarchyCell>
    )
  }
  const value = last(split(rowData?.[column?.field] || '', CATEGORY_INTERNAL_SEPERATOR))
  const count = rowData?.totalItems || ''
  return (
    <HierarchyCell>
      <Typography
        variant='label'
        classes={classNames({
          [css.parentTitle]: !rowData?.isLeaf
        })}
        style={{
          marginLeft: 10 * rowData.depth
        }}
      >
        {startCase(`${value} ${formatNumberByLocale(count)}`.toLowerCase())}
      </Typography>
    </HierarchyCell>
  )
}

export default ActivityFamilyLine
